<div class="form-group remax-input"
[class.full-width]="isFullWidth"
[class.has-error]="isInvalid">
  <label [for]="inputId" *ngIf="label">{{label}}</label>
  <div class="has-pos-rel input-wrapper" [formGroup]="parentFormGroup">
    <input class="form-control"
      [attr.aria-label]="ariaTranslateTag | translate"
      [id]="inputId"
      (blur)="onBlur.emit($event)"
      [type]="inputType"
      [placeholder]="placeholder"
      [name]="inputId"
      [pattern]="pattern"
      (focus)="onFocus.emit($event)"
      (ngModelChange)="onModelChange($event)"
      [formControl]="formControl"
      #inputRef/>
      <!-- TODO: maybe add something where they can pass in errors object/array -->
    <ng-content></ng-content>
  </div>
  <ng-template [ngIf]="isRequired && formControl.touched && this.formControl.value === ''" [ngIfElse]="notRequired">
    <p class="error-clue" translate="errors.field-is-required"></p>
  </ng-template>
  <ng-template #notRequired>
    <ng-container *ngIf="isInvalid">
      <ng-template [ngIf]="formControl.errors?.minlength || formControl.errors?.maxlength" [ngIfElse]="customError">
        <p class="error-clue" *ngIf="formControl.errors?.minlength" translate="errors.min-length" [translateParams]="{ x: formControl.errors.minlength.requiredLength }"></p>
        <p class="error-clue" *ngIf="formControl.errors?.maxlength" translate="errors.max-length" [translateParams]="{ x: formControl.errors.maxlength.requiredLength }"></p>
      </ng-template>
      <ng-template #customError>
        <p class="error-clue">{{errorText}}</p>
      </ng-template>
    </ng-container>
  </ng-template>
</div>
